import Main from '@/components/main/Main';
import filterRoutes from './permissionUtil';
// system
import systemRoutes from '@/emc-system/routes/system';
import commonRoutes from '@/emc-common/routes/common';
import accountRoutes from '@/emc-dmp/routes/dmp-account';
import dmpRoutes from '@/emc-dmp/routes/dmp';
import dmpMaterialRoutes from '@/emc-dmp/routes/dmp-material';
import dmpCampaignRoutes from '@/emc-dmp/routes/dmp-campaign';
import dmpAdRoutes from '@/emc-dmp/routes/dmp-ad';
import dmpReportRoutes from '@/emc-dmp/routes/dmp-report';
import qlRoutes from '@/bysc-ql/routes/ql';
let defaultRoutes = [
  {
    name: '_home',
    path: '/home',
    component: Main,
    redirect: '/home/index',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '首页',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'home',
        path: '/home/index',
        // TODO 这里变更首页
        component: () => import('@/bysc-ql/views/home'),
        meta: {
          showInMenu: true,
          path: '/home',
          title: '系统首页',
          icon: 'logo-apple'
        }
      },
      {
        name: 'editPassword',
        path: '/home/editPassword',
        component: () => import('@/views/editPassword'),
        meta: {
          showInMenu: false
        }
      }
    ]
  }
];
export default permissions => {
  let allRoutes = _.cloneDeep(defaultRoutes);
  allRoutes = allRoutes.concat(systemRoutes); // 合并系统模块
  allRoutes = allRoutes.concat(dmpRoutes); // 合并dmp模块
  allRoutes = allRoutes.concat(accountRoutes); // 合并dmp账户模块
  allRoutes = allRoutes.concat(dmpMaterialRoutes); // 合并dmp素材库
  allRoutes = allRoutes.concat(dmpCampaignRoutes); // 合并dmp监测
  allRoutes = allRoutes.concat(dmpAdRoutes); // 合并dmp广告投放
  allRoutes = allRoutes.concat(dmpReportRoutes); // 合并dmp数据报表
  allRoutes = allRoutes.concat(commonRoutes); // 合并公共模块
  allRoutes = allRoutes.concat(qlRoutes); // 合并视频模块

  allRoutes = _.cloneDeep(allRoutes);
  filterRoutes(allRoutes, permissions);
  allRoutes.push({
    path: '*',
    redirect: allRoutes[0].path
  });
  return allRoutes;
};
